import React from 'react';
import '@/views/account/assets/policy.scss';

const ServicesRender = () => {
  return (
    <div className='policy bg-light py-5' style={{ fontSize: 16 }}>
      <h1 className='container text-center bg-light mt-2 mt-md-5 mb-4 mb-md-5'>
        Terms of Service
      </h1>
      <div className='container-xxl'>
        <div className='bg-white p-md-5 p-4'>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Introduction</h2>
            <p>
              Thanks for using HitPaw Online product and related services
              (“Online”, “we” or “us”)!
            </p>
            <p>
              HitPaw Online provides you with basic online audio and video
              editing services (video cropping, video watermark removal, video
              compression, etc.).
            </p>
            <p>
              HitPaw Online products and related services are legally owned and
              operated by HitPaw Technology Co., Ltd.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Legal Agreement</h2>
            <p>
              Before you start using this product and related services, please
              carefully read all the terms and conditions listed in this
              agreement (minors under the age of 18 should read with their legal
              guardians), and focus on reading our exemptions or restrictions
              displayed in bold HitPaw Online liability clauses, agreed dispute
              resolution methods and jurisdiction clauses, separate agreements
              or business rules clauses, etc. If you have any questions about
              the terms of this agreement, please contact our company, and we
              will explain the content of the terms for you. If you do not agree
              to any of the terms of this agreement, or cannot accurately
              understand the company’s interpretation of the relevant terms,
              please do not proceed with subsequent consent operations. You know
              that if you perform follow-up operations or click to confirm, it
              is deemed that you fully understand and accept all the terms of
              this agreement, and this agreement constitutes a binding legal
              document between the company and you.
            </p>
            <p>
              For the purposes of these terms of service, "you" refers to an
              entity that accepts these terms of service as an individual or on
              your behalf and is endowed with all rights and is bound by all
              terms under the agreement. You represent that you have the right
              to accept these terms and conditions of service. If you do not
              agree to all the constraints of the terms of service, please stop
              using any HitPaw Online services or products immediately, which
              will cause the company to be unable to provide you with complete
              product and services.
            </p>
            <p>
              You can contact us at the email address below, and we will
              generally reply to you within 10 days.
            </p>
            <p className='text-primary'>support@hitpaw.com</p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Account User Information</h2>
            <p>
              In order to use the HitPaw Online services, you must provide your
              email address. You agree that your email address will always be
              accurate and up-to-date.
            </p>
            <p>
              If you are a child under the age of 13, please provide your legal
              guardian's email address so that we can obtain consent. If you are
              unable to provide it, please stop using any HitPaw Online services
              or products immediately.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Privacy Policy</h2>
            <p>
              You agree to our collection and use of your email address and
              other information in accordance with our privacy policy. The
              privacy policy of this product and service is detailed in the
              "User Privacy Policy". You agree to read carefully and fully
              understand and accept the privacy policy, and agree that the
              privacy policy is an important part of this agreement.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Your Use of The Service</h2>
            <p>
              When you use this product and related services, it will involve
              information from many people and entities, including data, text,
              photos, graphics, videos and messages, labels or other materials
              (collectively, "Content”). Content is the responsibility of the
              person or entity that provides it to the service. This means that
              you are responsible for all audio and video content you process
              during the use of the service (including third-party service
              integration enabled through the service) and the resulting
              behavioral consequences (including any loss or damage that hitpaw
              online may suffer).
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Feedback to HitPaw Online</h2>
            <p>
              By submitting feedback, ideas, ratings, comments or suggestions to
              HitPaw Online privately through customer service ("Feedback"), you
              acknowledge and agree:
            </p>
            <ul>
              <li className='mb-2'>
                Your feedback will automatically become the property of HitPaw
                Online, and HitPaw Online has no obligation to you;
              </li>
              <li className='mb-2'>
                Your feedback does not contain confidential or proprietary
                information of you or any third-party;
              </li>
              <li className='mb-2'>
                HitPaw Online can use or disclose such feedback in any media
                around the world in any way for any lawful purpose;
              </li>
              <li className='mb-2'>
                HitPaw Online may have some similar feedback that is already
                under consideration or development;
              </li>
              <li className='mb-2'>
                You are not entitled to any form of compensation from HitPaw
                Online.
              </li>
            </ul>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Software Improvement Plan</h2>
            <p>
              HitPaw Online is committed to helping protect your privacy at all
              times, unless otherwise stipulated in this agreement. This
              statement explains the anonymous data collection process and usage
              practices of the HitPaw Online software improvement program.
            </p>
            <p>
              In order to provide and improve the software, its functions and
              user experience, we will automatically collect and maintain
              process and usage information related to the use of various
              modules and functions of the HitPaw Online software. For the
              purpose of statistical analysis of software usage, information
              will also be collected anonymously.
            </p>
            <p>
              We will only use this information for the purpose of providing the
              end user with the best software experience. The collected data
              will not be disclosed, shared, sold, traded or leased to any
              third-party for marketing purposes.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Member Conduct</h2>
            <p className='fw-bold'>
              You agree not to use the service for the following:
            </p>
            <ul className='mb-3'>
              <li className='mb-2'>Harm minors in any way;</li>
              <li className='mb-2'>
                Impersonate any person or entity, or misrepresent your
                affiliation with that person or entity;
              </li>
              <li className='mb-2'>
                Engage in any unsolicited or unauthorized advertising, "spam" or
                "chain letter" or any other form of solicitation;
              </li>
              <li className='mb-2'>
                Transmit or provide any material containing software viruses or
                computer codes, files or programs designed to interrupt, destroy
                or limit the functions of any computer software, hardware or
                telecommunications equipment;
              </li>
              <li className='mb-2'>
                Interfering with or destroying the service or the server or
                network connected to the service;
              </li>
              <li className='mb-2'>
                Intentionally or unintentionally violate any applicable local,
                state, national or international laws;
              </li>
            </ul>
            <p className='fw-bold'>
              You agree not to upload, publish, transmit or provide any of the
              following:
            </p>
            <ul className='mb-3'>
              <li className='mb-2'>
                Illegal, harmful, threatening, abusive, harassing, infringing,
                defamatory, obscene, defamatory, infringing on the privacy of
                others, hatred or racial, racial or other offensive content;
              </li>
              <li className='mb-2'>
                Without authorization, providing information in accordance with
                any law or contract or trust relationship (such as internal
                information, proprietary and confidential information protected
                by non-disclosure agreements) infringes any patent, trademark,
                trade secret, copyright, or other proprietary rights of any
                party. You acknowledge that HitPaw Online may or may not
                pre-screen content. We have the right but not the obligation to
                decide on our own to pre-screen, reject or delete any content on
                the service. You need to understand that you may be exposed to
                offensive, indecent or offensive service content.
              </li>
            </ul>
            <p className='fw-bold'>
              You will not be able to access this service under the following
              conditions:
            </p>
            <ul>
              <li className='mb-2'>
                Through any means other than the provided interface;
              </li>
              <li className='mb-2'>
                Through any automated means (including the use of robots,
                scripts or web scraping tools). You must not rewrite or
                circumvent any security components, and you must not violate any
                usage rules related to the protection of materials or
                technologies in this service.
              </li>
            </ul>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Exclusive Rights</h2>
            <p>
              All right, title and interest in and to the services (including
              any HitPaw Online content or materials provided through the
              service, the appearance, design, service mark, trademark and
              service name of the service) are the exclusive property of HitPaw
              Online and its affiliates, licensors or users, and are protected
              by copyright, patent, trademark or other ownership and laws.
              Without the prior written consent of the service owner, you can
              not use, copy, modify, create derivative products, and reverse
              engineer any part of the product, sell, transfer, sublicense or
              transfer any rights by other means.
            </p>
            <p>
              Unless there is another agreement between HitPaw Online and you,
              as far as any software we provide to you, HitPaw Online grants you
              the personal exclusivity, global, royalty-free, non-transferable
              and non-exclusive license of such software provided whose sole
              purpose is to enable you to use the service in the manner
              permitted by these terms of service. You must not (and you must
              not allow anyone else) copy, modify, create derivative products,
              reverse engineer, decompile or attempt by other means to extract
              the source code of the software or any part of it. You must not
              assign or grant sub-license of the right of the software you use,
              grant your right to use the software or a security interest in the
              right to use the software, or transfer any part of your right to
              use the software by other means.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Third Party Charges</h2>
            <p>
              You (not HitPaw Online) are solely responsible for any costs
              incurred when accessing services via Internet or mobile access
              providers or other third-parties, including but not limited to the
              costs incurred by sending or receiving SMS messages.
            </p>
            <p>
              When the company provides services, it may charge certain fees to
              users of related services. In this case, the company will make
              clear prompts or guidelines on the relevant pages. If the user
              needs to pay for the service used, the user has the right to
              decide whether to use and accept the charged service. If the user
              refuses to pay such fees, the related services cannot be used.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>No Resale of Service</h2>
            <p>
              You agree to use the services only for personal purposes and not
              for any unintended purposes. You agree not to reproduce, copy,
              plagiarize, sell, trade, resell, construct or use any part of the
              service website for any commercial purpose.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Announcements</h2>
            <p>
              This service may display announcements. Taking into account that
              HitPaw Online grants you the right to access and use the service,
              you agree that HitPaw Online may publish such statements on the
              service.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Indemnity</h2>
            <p>
              You agree to indemnify HitPaw Online and its affiliates, members,
              officers, agents, employees, partners and licensors, and to
              protect them from any claims or requirements arising from any
              third-party due to the content you submit, publish, or transmit,
              Including reasonable attorney fees, travel expenses, etc., service
              provision, your use of the service, connection with the service,
              violation of the terms of service or violation of the rights of
              others.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Modifications to Service</h2>
            <p>
              We reserve the right to temporarily or permanently change or
              terminate the service (or any part of it) without notice. You
              agree that HitPaw Online is not responsible for any modification,
              suspension or termination of this service by you or any third
              party. You further agree that we can unilaterally decide to limit
              the number of emails sent through the service at any time.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Termination</h2>
            <p>
              You agree that HitPaw Online can terminate your application's
              access to the service at any time for the following reasons
              (including but not limited to) without prior notice:
            </p>
            <ul>
              <li className='mb-2'>
                Violation or violation of these Terms of Service or other
                incorporated agreements or guidelines;
              </li>
              <li className='mb-2'>
                Requirements of law enforcement agencies or other government
                agencies;
              </li>
              <li className='mb-2'>
                Your request to deactivate the application;
              </li>
              <li className='mb-2'>
                Termination or major modification of the service;
              </li>
              <li className='mb-2'>Unexpected technical or safety issues;</li>
              <li className='mb-2'>
                You engage in fraudulent or illegal activities;
              </li>
              <li className='mb-2'>
                You do not pay any fees related to the service. In addition, you
                agree that HitPaw Online is not responsible for you or any
                third-party for any deactivation of your application.
              </li>
            </ul>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Disclaimers</h2>
            <p>You clearly understand and agree:</p>
            <ul>
              <li className='mb-2'>
                Your use of the services is at your own risk. The service is
                provided on a "no change" and "available" basis. The HitPaw
                Online and its branches, members, officials, employees, agents,
                partners and licensors disclaim all warranties, whether express
                or implied, including but not limited to merchantability,
                fitness for a particular purpose, or non-infringement.
              </li>
              <li className='mb-2'>
                HitPaw Online and its affiliates, members, managers, employees,
                agents, partners and licensors do not guarantee that the service
                will meet your requirements; or that the service will be
                uninterrupted, timely, safe, error-free or free of viruses or
                other harmful components.
              </li>
              <li className='mb-2'>
                Any materials downloaded or otherwise obtained through the use
                of this service are at your own discretion and risk, and you
                will be solely responsible for any computer system damage or
                data loss caused by downloading any such materials.
              </li>
              <li className='mb-2'>
                Under no circumstances will HitPaw Online be liable for any
                content, including but not limited to any errors or omissions in
                any content, or any data loss or damage due to the use of any
                content posted through the service, sent by email, transfer or
                otherwise. You agree that you must evaluate and bear all risks
                associated with the use of any content, including any reliance
                on the accuracy, completeness or usefulness of such content.
              </li>
              <li className='mb-2'>
                Any opinions, statements, suggestions or other information
                provided or expressed by third parties or users are those of the
                corresponding third parties or users, not HitPaw Online.
                Although we actively seek community participation in the content
                on our website through various means, we do not endorse and are
                not responsible for the reliability or accuracy of any
                suggestions, opinions or statements on this service.
              </li>
            </ul>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Limitation of Liability</h2>
            <p>
              You clearly understand and agree that HitPaw Online and its
              affiliates, members, managers, employees, agents, partners and
              licensors shall not be liable for any direct, indirect,
              incidental, special, consequential or punitive damages, including
              but it is not limited to damage caused by loss of profit,
              goodwill, use, data or other intangible losses (even if HitPaw
              Online has been notified of the possibility of such damage), the
              reasons are:
            </p>
            <ul>
              <li className='mb-2'>Use or inability to use the service;</li>
              <li className='mb-2'>
                The purchase cost of substitute goods and services arising from
                any purchase or acquisition of goods, data, information or
                services, information obtained through services or transactions
                concluded through services;
              </li>
              <li className='mb-2'>
                Any materials downloaded or otherwise obtained through the use
                of this service are at your own discretion and risk, and you
                will be solely responsible for any computer system damage or
                data loss caused by downloading any such materials.
              </li>
              <li className='mb-2'>
                Unauthorized access or modification of your transmission or
                data;
              </li>
              <li className='mb-2'>
                Any third party's statement or behavior on this service;
              </li>
              <li className='mb-2'>
                Any other matters related to the service. Some jurisdictions do
                not allow the exclusion of certain guarantees, nor the
                limitation or exclusion of liability for incidental or indirect
                losses. Therefore, some of the above restrictions may not apply
                to you.
              </li>
            </ul>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Notice</h2>
            <p>
              We may send you notices, including notices about changes to the
              terms of service, all notices can be through any contact method
              you reserved (including but not limited to email, regular mail,
              mobile phone text messages) or, announcements on this website and
              other reasonable methods known or developed in the future.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>
              Notice and Procedure for Making Claims of Copyright Infringement
            </h2>
            <p>
              We respect the intellectual property of others and ask our users
              to do the same. If you believe that your work has been copied in a
              way that constitutes copyright infringement, or your intellectual
              property rights have been infringed, please contact us.
            </p>
          </div>
          <div className='cell mb-4 mb-md-5'>
            <h2 className='sub mb-4 mb-md-5'>Improve</h2>
            <p>
              HitPaw Online reserves the right to revise or modify the service
              at any time and to revise or modify any terms and conditions
              contained in these terms of service or any policy governing the
              service at any time. You are responsible for regularly checking
              any updates to these terms of service on [here is the URL of this
              terms of service], and we will also notify you. If you do not
              agree to the relevant changes after HitPaw Online updates these
              terms, you should immediately stop using this product and service.
              If you click to agree to continue using the service, it will be
              deemed as your agreement and compliance with any modified
              agreement and rules.
            </p>
            <p className='fw-bold fs-6'>Support Changes to Service</p>
            <p>
              HitPaw Online can choose to provide you with customer support at
              its sole discretion, and can terminate such support at any time
              without notice. HitPaw Online can change, restrict, suspend or
              terminate any aspect of the service at any time, including the
              availability of any function or content.
            </p>
            <p className='fw-bold fs-6'>Governing Law and Dispute Resolution</p>
            <p>
              The validity, interpretation, modification, performance and
              dispute resolution of this agreement shall be governed by the laws
              and regulations of the People's Republic of China (for the purpose
              of this agreement, excluding Hong Kong, Macau, and Taiwan). In the
              event of a dispute arising from the signing, performance or
              interpretation of this agreement, you and the company shall
              negotiate and resolve the issue in an equal, friendly, and
              reasonable manner; if the negotiation fails, either party shall
              bring a lawsuit to the people’s court where the company is
              located.
            </p>
            <p className='fw-bold fs-6'>General</p>
            <p>
              If any provision in these terms of service should be ruled as
              illegal or unenforceable by a court with jurisdiction, the
              provision shall be modified to the extent necessary to make it
              enforceable without losing its intent, or if If such modification
              cannot be made, it should be deleted from this service clause, and
              the remaining provisions of these terms will remain in full force
              and effect. The control language of the terms of service is
              English. In any case, any party waiving any of the terms or
              conditions of these terms of service or any of its violations
              shall not waive the terms or conditions or any of its subsequent
              violations. You must not transfer any rights or obligations under
              these terms of service or this agreement through legal or other
              means. Any such alleged transfer or assignment will be invalid. In
              addition to the above provisions, these terms of service are
              binding on both parties, their heirs and assigns, and their
              interests shall be ensured. These terms of service, user privacy
              policy and possible supplementary agreements constitute the entire
              agreement between the two parties on this subject and are legally
              binding on both parties.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesRender;
